const base_url =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://api.spacegame.remus.page";
export default base_url;
